<template lang='pug' src='./blog-page.pug'></template>

<script>
export default {
  computed: {
    props () {
      let blogSlug = this.$route.params.blog
      return this.$store.state.blog[blogSlug]
    }
  },
  mounted () {
    console.log(this.props)
  }
}
</script>



// WEBPACK FOOTER //
// blog-page.vue?675bcc10